<div class="tw:bg-surface-primary tw:rounded-lg tw:shadow tw:p-4 tw:min-w-[240px]">
	@if (!isInternalView) {
		<app-topbar-user-profile-menu-item icon="person" routerLink="/user/general" routerLinkActive="active">
			{{ "profile.myProfile" | translate }}
		</app-topbar-user-profile-menu-item>

		@if (!userRole.isStoresManager()) {
			<app-topbar-user-profile-menu-item icon="support_agent" routerLink="/customer-support" routerLinkActive="active">
				{{ "profile.customerSupport" | translate }}
			</app-topbar-user-profile-menu-item>

			<app-topbar-user-profile-menu-item icon="villa" routerLink="/settings/school" routerLinkActive="active">
				{{ "profile.schoolProfile" | translate }}
			</app-topbar-user-profile-menu-item>

			<app-topbar-user-profile-menu-item
				icon="rule_settings"
				routerLink="/settings/preferences"
				routerLinkActive="active"
			>
				{{ "profile.preferences" | translate }}
			</app-topbar-user-profile-menu-item>
		}
		<!--  -->
	}

	<button
		(click)="logOut()"
		class="tw:px-1 tw:py-4 tw:bg-transparent tw:text-base! tw:font-medium tw:text-secondary tw:border-none tw:hover:text-default"
	>
		Log out
	</button>
</div>
